import { ErrorCode, PortalApiError } from '@afterpaytouch/portal-api/types'
import { Route } from '../../config/router'
import { TrackingEvent } from '../../model/monitoring'
import { ErrorHandler, CheckoutErrorContext } from './types'

export const createCheckoutStartProfileErrorHandler = (): ErrorHandler => {
  const profileErrorCodes = [ErrorCode.profileRefreshOverdueRequired, ErrorCode.VerifiedMobileMissing]

  return {
    canHandle: (errorCode: ErrorCode, error: PortalApiError): boolean => {
      return profileErrorCodes.includes(errorCode)
    },

    handle: async (errorCode: ErrorCode, error: PortalApiError, context: CheckoutErrorContext): Promise<Route | undefined> => {
      context.logEvent(TrackingEvent.CHECKOUT_DECLINED, {
        isRecoverableTerminalError: false,
        errorCode,
      })

      if (errorCode === ErrorCode.profileRefreshOverdueRequired) {
        return Route.KYC_CONFIRM_DETAILS
      }

      if (errorCode === ErrorCode.VerifiedMobileMissing) {
        const verifiedMobileMissingRoute = context.unverifiedMobileRoute()
        return verifiedMobileMissingRoute
      }

      return undefined
    },
  }
}
